import { Menu, MenuButton, MenuList, MenuItem, Flex, Icon, Button } from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { MdEmail, MdPhone } from 'react-icons/md'
import { FaWhatsapp } from 'react-icons/fa'
import { useReducer } from 'react'
import { useFormContext } from 'react-hook-form'

export function CustomSelect({ onChange = () => {}, value = 'EMAIL', ...props }) {
  const { setValue } = useFormContext()
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'EMAIL':
          return { email: true, whatsapp: false, telefone: false }
        case 'WHATSAPP':
          return { email: false, whatsapp: true, telefone: false }
        case 'TELEFONE':
          return { email: false, whatsapp: false, telefone: true }
        default:
          return state
      }
    },
    {
      email: true,
      whatsapp: false,
      telefone: false,
    }
  )

  const getSelectedOption = () => {
    if (state.email) return { label: 'Retornar por Email', icon: MdEmail, color: 'orange.500' }
    if (state.whatsapp)
      return {
        label: 'Retornar por Whatsapp',
        icon: FaWhatsapp,
        color: 'green.500',
      }
    if (state.telefone) return { label: 'Retornar por Ligação', icon: MdPhone, color: 'black' }
  }

  const selectedOption = getSelectedOption()

  function handleSelect(value) {
    setValue('mensagem', '')
    dispatch({ type: value })
    onChange(value)
    setValue('agendamentoRetorno', value)
  }

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        border="1px"
        borderColor="#378BBF"
        borderRadius="md"
        bg="white"
        w="100%"
        p={1}
        textAlign="left"
        fontSize="sm"
      >
        <Flex align="center">
          <Icon as={selectedOption.icon} color={selectedOption.color} boxSize={4} mr={2} />
          {selectedOption.label}
        </Flex>
      </MenuButton>
      <MenuList borderColor="#378BBF">
        <MenuItem onClick={() => handleSelect('EMAIL')}>
          <Flex align="center">
            <Icon as={MdEmail} color="orange.500" boxSize={4} mr={2} />
            Retornar por Email
          </Flex>
        </MenuItem>
        <MenuItem onClick={() => handleSelect('WHATSAPP')}>
          <Flex align="center">
            <Icon as={FaWhatsapp} color="green.500" boxSize={4} mr={2} />
            Retornar por Whatsapp
          </Flex>
        </MenuItem>
        <MenuItem onClick={() => handleSelect('TELEFONE')}>
          <Flex align="center">
            <Icon as={MdPhone} color="black" boxSize={4} mr={2} />
            Retornar por Ligação a
          </Flex>
        </MenuItem>
      </MenuList>
    </Menu>
  )
}
